<div class="finances-container">

    <div class="header">
        <div class="left">
            <h2 mat-title>Categories</h2>
        </div>
        <div class="right">
            <button mat-stroked-button (click)="createDefaults()" title="Cria as categorias da planilha que ainda não existem">Default categories</button>
            <button mat-icon-button (click)="edit()">
                <mat-icon class="material-symbols-outlined">{{icons.add}}</mat-icon>
            </button>
        </div>
    </div>

    <div class="groups">
        <section *ngFor="let group of groups">
            <h3>{{ group.label }}</h3>
            <table mat-table [dataSource]="byGroup(group.value)">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let c">{{ c.name }}</td>
                </ng-container>
                <ng-container matColumnDef="active">
                    <th mat-header-cell *matHeaderCellDef>Active</th>
                    <td mat-cell *matCellDef="let c">
                        <mat-icon class="material-symbols-outlined">{{ c.active ? icons.active : icons.inactive }}</mat-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let c">
                        <button mat-icon-button (click)="edit(c)"><mat-icon color="primary" class="material-symbols-outlined">{{icons.edit}}</mat-icon></button>
                        <button mat-icon-button (click)="delete(c)"><mat-icon color="primary" class="material-symbols-outlined">{{icons.delete}}</mat-icon></button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columns"></tr>
                <tr mat-row *matRowDef="let row; columns: columns;"></tr>
            </table>
            <p class="empty" *ngIf="!byGroup(group.value).length">No categories.</p>
        </section>
    </div>
</div>
